module.exports = "/fonts/nucleo-icons.woff?c82c9b7c40130b7116d3cec28196169a";